import {
  SET_KNOWLEDGE_BASE,
  UPDATE_KNOWLEDGE_BASE,
  UPDATE_KNOWLEDGE_BASE_ITEMS,
  UPDATE_OPEN_KNOWLEDGE_BASE_ITEMS,
  UPDATE_KNOWLEDGE_ITEM_ERRORS,
  UPDATE_KNOWLEDGE_BASE_ACCORDION_ERROR,
} from "../actions/KnowledgeBaseActions";

const initialState = {
  knowledgeBaseItems: [],
  updatedKnowledgeBaseItems: [],
  knowledgeItemErrors: [],

  knowledgeBaseAccordionError: null,

  openKnowledgeBaseItems: [],

  config: {
    minKnowledgeItemsListSize: 0,
    maxKnowledgeItemsListSize: 15,
    minKnowledgeItemTitleCharacters: 3,
    maxKnowledgeItemTitleCharacters: 100,
    minKnowledgeItemDescriptionCharacters: 10,
    maxKnowledgeItemDescriptionCharacters: 1000,
  },
};

const knowledgeBaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_KNOWLEDGE_BASE:
      return {
        ...state,
        knowledgeBaseItems: [...action.payload.knowledgeBaseItems] ?? [],
        updatedKnowledgeBaseItems: [...action.payload.knowledgeBaseItems] ?? [],
        config: action.payload.config ?? state.config,
      };
    case UPDATE_KNOWLEDGE_BASE_ITEMS:
      return {
        ...state,
        updatedKnowledgeBaseItems: [...action.payload],
        knowledgeBaseAccordionError: null,
      };
    case UPDATE_KNOWLEDGE_BASE:
      return {
        ...state,
        updatedQuestions: action.payload,
      };

    case UPDATE_OPEN_KNOWLEDGE_BASE_ITEMS:
      return {
        ...state,
        openKnowledgeBaseItems: action.payload,
      };
    case UPDATE_KNOWLEDGE_ITEM_ERRORS:
      return {
        ...state,
        knowledgeItemErrors: action.payload,
      };

    case UPDATE_KNOWLEDGE_BASE_ACCORDION_ERROR: {
      return {
        ...state,
        knowledgeBaseAccordionError: action.payload,
      };
    }
      

    case "CANCEL": {
      return {
        ...state,
        updatedKnowledgeBaseItems: [...state.knowledgeBaseItems],
        openKnowledgeBaseItems: [],
        knowledgeItemErrors: [],
      };
    }
    case "SAVED": {
      return {
        ...state,
        knowledgeBaseItems: [...state.updatedKnowledgeBaseItems],
        openKnowledgeBaseItems: [],
        knowledgeItemErrors: [],
      };
    }

    default:
      return state;
  }
};

export default knowledgeBaseReducer;
